import { FORM_PAGES } from '../Form/types';

export enum FORM_INFO_TYPES {
  CREATED_ACCOUNT = 'CREATED_ACCOUNT',
  SUMMARY = 'SUMMARY',
  FORM_FILL_SUMMARY = 'FORM_FILL_SUMMARY',
  BOOKING_ORDER = 'BOOKING_ORDER',
  BOOKING_ORDER_SUBSCRIPTION = 'BOOKING_ORDER_SUBSCRIPTION',
  BOOKING_HANDLING = 'BOOKING_HANDLING',
  BOOKING_ORDER_RECURRING = 'BOOKING_ORDER_RECURRING',
  FORM_QUESTIONS = 'FORM_QUESTIONS',
  BROWSER_NOT_SUPPORTED = 'BROWSER_NOT_SUPPORTED',
  FORMS_FILLED = 'FORMS_FILLED'
}

export const FORM_INFO_COMPONENT_TYPES = {
  CREATED_ACCOUNT: {
    title: 'Great! An account has been created for you!',
    body: 'Now let’s add your pet’s details.',
    registerAs: ''
  },
  SUMMARY: {
    title: 'Summary',
    body: '',
    registerAs: 'SELECTED_DEFAULT_PAYMENT_METHOD'
  },

  BOOKING_ORDER: {
    title: 'Your booking request has been placed for the {{date}}. We will notify you once your booking has been confirmed.',
    body: 'To manage this booking, book new services, edit your pet profile and much more, download the Collar mobile app{{downloadMethod}}.',
    registerAs: ''
  },

  BOOKING_ORDER_RECURRING: {
    title: 'Your booking requests have been placed. We will notify you once your bookings have been confirmed.',
    body: 'To manage this booking, book new services, edit your pet profile and much more, download the Collar mobile app{{downloadMethod}}.',
    registerAs: ''
  },

  BOOKING_ORDER_SUBSCRIPTION: {
    title: 'Thank you for subscribing to the {{subscriptionName}}.',
    body: 'To access the full benefits of your membership, edit your pet profile, receive messages and access reports, download the Collar mobile app by{{downloadMethod}}.',
    registerAs: ''
  },

  BOOKING_HANDLING: {
    title: 'Please authorise your previous payment',
    body: 'Your previous payment is pending authentication from your card issuer. Please click the button below to complete the authentication process with your bank.',
    registerAs: ''
  },

  FORM_QUESTIONS: {
    title: 'We’d love to gather a bit more information to ensure we can offer you and your pet the best service.',
    body: '',
    registerAs: ''
  },

  BROWSER_NOT_SUPPORTED: {
    title: 'Your browser is not supported',
    body: 'Please use a different browser to continue or download the Collar mobile app{{downloadMethod}}.',
    registerAs: ''
  },

  FORM_FILL_SUMMARY: {
    title: 'Preview',
    body: '',
    registerAs: ''
  },

  FORMS_FILLED: {
    title: 'Thank you for submitting your information.',
    body: 'To manage your account, pet profile book services and purchase products, download the Collar app{{downloadMethod}}.',
    registerAs: ''
  }
} as const;

export enum FORM_INFO_FIELD_TYPES {
  PRODUCT = 'PRODUCT',
  PETS = 'PETS',
  DATE = 'DATE',
  DATE_UNTIL = 'DATE_UNTIL',
  PRICE = 'PRICE',
  MULTI_PRICE = 'MULTI_PRICE',
  DISCOUNT_SUBSCRIPTION = 'DISCOUNT_SUBSCRIPTION',
  VARIATIONS = 'VARIATIONS',
  APPLIED_DISCOUNT = 'APPLIED_DISCOUNT'
}

export const FORM_INFO_COMPONENT_FIELD_TYPES = {
  PRODUCT: {
    title: `{{productType}}`,
    desciption: ''
  },
  VARIATIONS: {
    title: 'Options',
    desciption: ''
  },
  PETS: {
    title: 'Pets',
    description: ''
  },
  DATE: {
    title: `{{slot}}`,
    description: ''
  },
  DATE_UNTIL: {
    title: `To`,
    description: ''
  },
  PRICE: {
    title: 'Fees',
    description: ''
  },
  MULTI_PRICE: {
    title: 'Date, time & Fees',
    description: ''
  },
  DISCOUNT_SUBSCRIPTION: {
    title: 'Discount',
    description: ' User credit cannot be used for a subscription.'
  },
  APPLIED_DISCOUNT: {
    title: 'Applied Discount',
    description: ''
  }
} as const;

export enum FORM_INFO_SLOT_TYPES {
  SLOT = 'SLOT',
  MULTI_SLOT = 'MULTI_SLOT',
  MULTI_DAY = 'MULTI_DAY',
  RECURRENCE = 'RECURRENCE',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export const FORM_INFO_COMPONENT_SLOT_TYPES = {
  SLOT: {
    buttonErrorTitle: 'Slot is already booked',
    previousPage: FORM_PAGES.BOOKING_SELECT_PETS,
    dateTitle: 'Date & Time'
  },
  MULTI_SLOT: {
    buttonErrorTitle: 'Course is already booked',
    previousPage: FORM_PAGES.BOOKING_SELECT_PETS,
    dateTitle: 'Classes'
  },
  MULTI_DAY: {
    buttonErrorTitle: 'Days are already booked',
    previousPage: FORM_PAGES.BOOKING_SELECT_PETS,
    dateTitle: 'From'
  },
  RECURRENCE: {
    buttonErrorTitle: 'Product is already booked',
    previousPage: FORM_PAGES.BOOKING_SELECT_PETS,
    dateTitle: 'Dates & Times'
  },
  SUBSCRIPTION: {
    buttonErrorTitle: 'Already Subscribed',
    previousPage: FORM_PAGES.BOOKING_SELECT_PETS,
    dateTitle: 'Dates & Times'
  },
  FORMS_FILLED: {
    buttonErrorTitle: 'Already Filled',
    previousPage: FORM_PAGES.FORM_FILL_SUMMARY,
    dateTitle: 'Dates & Times'
  }
} as const;

export enum FORM_INFO_PAYMENT_DESCRIPTION {
  NO_CHARGE = 'NO_CHARGE',
  POSTPAID = 'POSTPAID'
}

export const FORM_INFO_COMPONENT_PAYMENT_DESCRIPTION = {
  NO_CHARGE: 'A valid payment method is required for security reasons. You will not be charged for free bookings or orders',
  POSTPAID:
    'This is a postpaid service. You will only be charged by {{branch}} at the end of your billing cycle for confirmed and past bookings. A Valid payment method is required to place any booking.'
} as const;
